<template>
  <div class="calculator percentage">
    <h1 class="page-header">Percentage Calculator</h1>
    <fieldset id="percentageof">
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col :span="4">
          <el-input id="percent" v-model="percent">
            <template #append>%</template>
          </el-input>
        </el-col>
        <el-col class="calc-text" :span="4">of</el-col>
        <el-col :span="4">
          <el-input v-model="percentof"></el-input>
        </el-col>
        <el-col :span="2">
          <span class="calc-text">=</span>
        </el-col>
        <el-col :span="4">
          <span class="calc-result">{{ percentofResult }}</span>
        </el-col>
      </el-row>
    </fieldset>
    <fieldset id="ispercentageof">
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col :span="4">
          <el-input id="ispercentValue" v-model="ispercentValue"></el-input>
        </el-col>
        <el-col :span="4">
          <span class="calc-text">is </span>
          <span class="calc-result">{{ ispercentResult }}%</span>
          <span class="calc-text"> of</span>
        </el-col>
        <el-col :span="4">
          <el-input id="ispercentValueOf" v-model="ispercentValueOf"></el-input>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="4"></el-col>
      </el-row>
    </fieldset>
    <fieldset id="ispercentageChange">
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col :span="4">
          <el-input id="change-start" v-model="isChangeStart"> </el-input>
        </el-col>
        <el-col :span="4"><i class="calc-text el-icon-right" /></el-col>
        <el-col :span="4">
          <el-input id="change-end" v-model="isChangeEnd"></el-input>
        </el-col>
        <el-col :span="2">
          <span class="calc-text">=</span>
        </el-col>
        <el-col :span="4">
          <span class="calc-result">
            {{ isChangeResult }}% {{ isChangeResultType }}
          </span>
        </el-col>
      </el-row>
    </fieldset>
    <fieldset id="percentageChange">
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col :span="4">
          <el-input v-model="changeAmount"></el-input>
        </el-col>
        <el-col :span="4">
          <div>
            <el-radio-group v-model="changeType">
              <el-tooltip
                class="item"
                effect="dark"
                content="Increase by"
                placement="bottom"
              >
                <el-radio-button label="increase">
                  <i class="el-icon-arrow-up" />
                </el-radio-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="Decrease by"
                placement="bottom"
              >
                <el-radio-button label="decrease">
                  <i class="el-icon-arrow-down" />
                </el-radio-button>
              </el-tooltip>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :span="4">
          <el-input v-model="changePercentage">
            <template #append>%</template>
          </el-input>
        </el-col>
        <el-col :span="2">
          <span class="calc-text">=</span>
        </el-col>
        <el-col :span="4">
          <span class="calc-result">{{ changeResult }}</span>
        </el-col>
      </el-row>
    </fieldset>
  </div>
</template>

<script>
import { toRefs, reactive, computed } from "vue"
import { useStore } from "vuex"
export default {
  name: "Percentage",
  setup() {
    const store = useStore()
    const state = reactive({
      percent: 100,
      percentof: 100,
      ispercentValue: 100,
      ispercentValueOf: 100,
      isChangeStart: 100,
      isChangeEnd: 50,
      changeType: "increase",
      changeAmount: 100,
      changePercentage: 100,
    })
    const decimalAdjust = computed(() => {
      return 10 ** store.state.decimalPlaces
    })

    const percentofResult = computed(() => {
      return (
        Math.round(state.percentof * state.percent * decimalAdjust.value) /
        decimalAdjust.value
      )
    })
    const ispercentResult = computed(() => {
      return (
        Math.round(
          ((state.ispercentValue * 100) / state.ispercentValueOf) *
            decimalAdjust.value
        ) / decimalAdjust.value
      )
    })
    const isChangeResult = computed(() => {
      return (
        Math.round(
          (Math.abs(state.isChangeStart - state.isChangeEnd) *
            100 *
            decimalAdjust.value) /
            state.isChangeStart
        ) / decimalAdjust.value
      )
    })
    const isChangeResultType = computed(() => {
      return state.isChangeStart >= state.isChangeEnd ? "decrease" : "increase"
    })
    const changeResult = computed(() => {
      const change = (state.changeAmount * state.changePercentage) / 100
      return state.changeType === "increase"
        ? Math.round((+state.changeAmount + change) * decimalAdjust.value) /
            decimalAdjust.value
        : Math.round((+state.changeAmount - change) * decimalAdjust.value) /
            decimalAdjust.value
    })

    return {
      ...toRefs(state),
      percentofResult,
      ispercentResult,
      isChangeResult,
      isChangeResultType,
      changeResult,
    }
  },
}
</script>

<style scoped>
</style>